export function TypingIndicator() {
  return (
    <div className="message message-assistant">
      <div className="typing-indicator">
        <div className="typing-dot" aria-hidden="true"></div>
        <div className="typing-dot" aria-hidden="true"></div>
        <div className="typing-dot" aria-hidden="true"></div>
        <span className="sr-only">Antwort wird geschrieben</span>
      </div>
    </div>
  );
}
